export default "__VITE_ASSET__DHc6nypc__"